import { provideJobLookup } from "@/composables/shared/queries";
import { useTreatmentPlanStore } from "@/stores/treatmentPlanStore";

/**
 * Hands the treatment-plan store to the query layer, which resolves a query's `jobSignal`
 * through it. Injected rather than imported there so the generic query composables do not
 * statically depend on the treatment-plan service graph.
 */
export function installQueryJobLookup(): void {
  provideJobLookup(() => useTreatmentPlanStore());
}
